import { notify } from 'utils/reduxUtils';

export const types = {
  FETCH_QUICKBOOKS_INFO_ERROR: 'integrations/FETCH_QUICKBOOKS_INFO_ERROR',
  FETCH_QUICKBOOKS_INFO_REQUEST:
    'settings/integrations/FETCH_QUICKBOOKS_INFO_REQUEST',
  FETCH_QUICKBOOKS_INFO_SUCCESS:
    'settings/integrations/FETCH_QUICKBOOKS_INFO_SUCCESS',
};

export const fetchQuickbooksInfo = {
  error: notify(
    (error) => ({
      type: types.FETCH_QUICKBOOKS_INFO_ERROR,
      payload: error,
    }),
    'Failed to initialize Quickbooks integration.',
  ),
  request: () => ({
    type: types.FETCH_QUICKBOOKS_INFO_REQUEST,
  }),
  success: ({ connected, error, url }) => ({
    type: types.FETCH_QUICKBOOKS_INFO_SUCCESS,
    payload: { connected, error, url },
  }),
};
